import { array, difference, intersection, reduceRight } from 'fp-ts/Array';
import { eqString } from 'fp-ts/Eq';
import { identity, tuple } from 'fp-ts/function';
import { fromFoldable } from 'fp-ts/Record';
import * as CU from './ctors';
import * as Ma from './matcher';
import * as M from './monocle';
import * as PU from './predicates';
const mergeKeys = (a, b) => (Object.assign(Object.assign({}, a), b));
const recordFromArray = fromFoldable({ concat: identity }, array);
const toTupleNull = (k) => tuple(k, null);
const intersectKeys = (a, b) => recordFromArray(intersection(eqString)(Object.keys(a), Object.keys(b)).map(toTupleNull));
const excludeKeys = (a, toRemove) => recordFromArray(difference(eqString)(Object.keys(a), toRemove).map(toTupleNull));
const keepKeys = (a, toKeep) => recordFromArray(intersection(eqString)(Object.keys(a), toKeep).map(toTupleNull));
/**
 *  @since 0.0.1
 */
export const unionADT = (as) => {
    const newKeys = reduceRight(as[0].keys, (x, y) => mergeKeys(x.keys, y))(as);
    return makeADT(as[0].tag)(newKeys);
};
/**
 *  @since 0.0.1
 */
export const intersectADT = (a, b) => makeADT(a.tag)(intersectKeys(a.keys, b.keys));
/**
 *  @since 0.0.1
 */
export const ofType = () => 1;
/**
 *  @since 0.0.1
 */
export const makeADT = (tag) => (_keys) => {
    const keys = _keys; // any
    const ctors = CU.Ctors(tag)(keys);
    const predicates = PU.Predicates(tag)(keys);
    const monocles = M.MonocleFor();
    const matchers = Ma.Matchers(tag)(keys);
    const select = (selectedKeys) => makeADT(tag)(keepKeys(keys, selectedKeys));
    const exclude = (excludedKeys) => makeADT(tag)(excludeKeys(keys, excludedKeys));
    const res = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ctors), predicates), monocles), matchers), { tag,
        keys,
        select,
        exclude });
    return res;
};
